import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`dark-header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="header-content">
        <div className="logo-container" onClick={() => scrollToSection('hero')}>
          <img 
            src="https://customer-assets.emergentagent.com/job_b51ca5cf-bc57-4be4-91f1-e0386a68d700/artifacts/sroy2sc2_WhatsApp%20Image%202026-03-14%20at%202.28.28%20AM.jpeg" 
            alt="LTechSolutions" 
            className="dark-logo"
          />
        </div>

        {/* Desktop Navigation */}
        <nav className="dark-nav desktop-nav">
          <button onClick={() => scrollToSection('hero')} className="dark-nav-link">
            Inicio
          </button>
          <button onClick={() => scrollToSection('services')} className="dark-nav-link">
            Servicios
          </button>
          <button onClick={() => scrollToSection('portfolio')} className="dark-nav-link">
            Portfolio
          </button>
          <button onClick={() => scrollToSection('contact')} className="dark-nav-link">
            Contacto
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <nav className="mobile-nav">
          <button onClick={() => scrollToSection('hero')} className="dark-nav-link">
            Inicio
          </button>
          <button onClick={() => scrollToSection('services')} className="dark-nav-link">
            Servicios
          </button>
          <button onClick={() => scrollToSection('portfolio')} className="dark-nav-link">
            Portfolio
          </button>
          <button onClick={() => scrollToSection('contact')} className="dark-nav-link">
            Contacto
          </button>
        </nav>
      )}
    </header>
  );
};

export default Header;
